import { useState, useEffect } from 'react';
import { getDownloadUrl } from '../../../data/firebase';

type CloudImageProps = {
  imageName: string;
};

const CloudImage = ({ imageName }: CloudImageProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<string | null>();

  useEffect(() => {
    if (imageName) {
      getDownloadUrl(imageName)
        .then((url: string) => {
          setImageUrl(url);
          setLoading(false);
        })
        .catch((error: any) => {
          console.error(error);
          setImageUrl(null);
          setLoading(false);
        });
    } else {
      setImageUrl('');
    }
  }, [imageName]);

  return [{ imageUrl, loading }];
};

export default CloudImage;
